import React from 'react';

import scss from './MessagesList.module.scss';

function EmptyMessagesList() {
  return <div className={scss.emptyWrapper} />;
}

export default EmptyMessagesList;
